// // Public entry points for the V-Tech UI.
// export { VtechRoutes } from './VtechRoutes';
// export { VtechLayout } from './components/VtechLayout';
// export {
//   HomePage,
//   AboutPage,
//   HoningPage,
//   ProductsPage,
//   ProductDetailPage,
//   ContactPage,
// } from './pages';

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import { HelmetProvider } from 'react-helmet-async';
// import VTechSite from './components/VTechSite';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <HelmetProvider>
//       <BrowserRouter>
//         <VTechSite
//           // all optional:
//           heroMedia="Diagram"    // 'Diagram' | 'Photo'
//           productLayout="Cards"  // 'Cards'   | 'List'
//           stickyQuote={true}
//         />
//       </BrowserRouter>
//     </HelmetProvider>
//   </React.StrictMode>
// );

// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { VtechRoutes } from './VtechRoutes';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <VtechRoutes />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);